import angular from 'angular';

angular.module('shbdeployer.app').factory('NameValidator', NameValidatorFactory);
/* @ngInject */
function NameValidatorFactory(EndpointService, Notifications) {
  return {
    validateEnvironmentName,
  };

  async function validateEnvironmentName(environmentName) {
    try {
      const endpoints = await EndpointService.endpoints();
      const endpointArray = endpoints.value;
      const nameDuplicated = endpointArray.filter((item) => item.Name === environmentName);
      return nameDuplicated.length > 0;
    } catch (err) {
      Notifications.error('Ошибка', err, 'Не удалось получить сведения об окружении');
    }
  }
}
